import RequestBase from "./RequestBase.ts";

export default class GroupServersRequests extends RequestBase {
    constructor(){
        super("GroupServers/");
    }
}